import React from "react";
import "./DNAElement.scss";
import { DNAFragment } from "./DNAFragment/DNAFragment";
import { DNAElementValue, DNAFragmentValue } from "../DNA";
import { clone } from "lodash";

interface IProps {
    value: DNAElementValue
    onChange?: (value: DNAElementValue) => void
}

export function DNAElement({ value, onChange }: IProps) {
    const buttonBar = (type: 'plus' | 'minus') => {
        return onChange ? (<div className={"button-bar"}>
            {value.map((fragmentValue, index) => {
                const handleClick = (clickedIndex: number) => {
                    return () => {
                        const newValue = clone(value);
                        if (type === 'plus') {
                            newValue[clickedIndex] = Math.min(newValue[clickedIndex] + 1, 2) as DNAFragmentValue;
                        } else if (type === 'minus') {
                            newValue[clickedIndex] = Math.max(newValue[clickedIndex] - 1, -2) as DNAFragmentValue;
                        }
                        onChange(newValue);
                    }
                };
                return <button
                    key={index}
                    disabled={(type === 'plus' && fragmentValue === 2) || (type === 'minus' && fragmentValue === -2)}
                    className={`dna-button ${type}-button`}
                    onClick={handleClick(index)}
                ></button>
            })}
        </div>) : undefined;
    }
    return (
        <div className="dna-element">
            {buttonBar('plus')}
            <div className="dna-element-wrapper">
                {value.map((fragmentValue, index: number) => {
                    return <DNAFragment key={index} value={fragmentValue} />
                })}
            </div>
            {buttonBar('minus')}
        </div>
    )
}
